module.exports = __webpack_public_path__ + "img/banner78.ecfa12ea.png";